export default __webpack_public_path__ + "static/loading-64b9064226a287c0ad9bb365d27c3604.gif";